import SplitPageCta from '../common/SplitPageCta'
import { contactImages } from '../../assets/images'
import { contactPageCta } from '../../data/contactPageData'

function ContactPageCta() {
  const { title, description, primaryCta, secondaryCta } = contactPageCta

  return (
    <SplitPageCta
      sectionClass="contact-page-cta"
      panelClass="contact-page-cta__panel"
      title={title}
      description={description}
      primaryCta={primaryCta}
      secondaryCta={secondaryCta}
      imageSrc={contactImages.ctaGlobalLogistics}
      useAnchor
    />
  )
}

export default ContactPageCta
